<!-- 登录 -->
<template>
    <div class="login_bg">
        <div class="reg" @click="openRegDia">系统注册</div>
        <div class="down" @click="openDownFire">客户端下载</div>
        <div class="login_logo">
            <el-image style="width: 200px;" :src="logoInfo.mainLogo" v-if="logoInfo.mainLogo != '' &&
            logoInfo.mainLogo != null &&
            logoInfo.mainLogo != undefined
         ">
            </el-image>
        </div>
        <div class="login_box">
            <div class="login_left">
                <div class="login_left_content">
                    <el-carousel indicator-position="outside" height="600px">
                        <el-carousel-item v-for="item in $store.state.bannerList" :key="item.id">
                            <el-image :src="item.url" fit="scale-down"></el-image>
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div class="login_right">
                <div class="login_right_content">
                    <div class="left_title_text">
                        <div class="" style="font-size: 1.2rem; font-weight: bold">
                            {{ loginName?loginName:logoInfo.loginTitle }}
                        </div>
                        <div class="">{{ logoInfo.purpose }}</div>
                    </div>
                    <div class="login_content_box">
                        <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="账号密码登录" name="first">
                
              </el-tab-pane>
              <el-tab-pane label="二维码登录" name="second">
                <div class="login_form_box">
                  <div class="login_qrcode_box" ref="qrCodeDiv"></div>
                </div>
              </el-tab-pane>
            </el-tabs> -->
                        <div class="login_form_box">
                            <div class="login-tt">
                                <div style="padding-left: 10px">登录</div>
                                <div class="blue-line"></div>
                            </div>

                            <div class="login_input_line">
                                <div class="login_input_left">
                                    <el-image src="/img/zh.png" class="login_input_left_img"></el-image>
                                </div>
                                <div class="login_input_right">
                                    <el-input type="text" v-model.trim="loginData.opmAccount" size="mini" @input="loginFunAcc" @keyup.enter.native="focusClick" placeholder="请输入您的账号"></el-input>
                                </div>
                            </div>
                            <div class="login_input_line">
                                <div class="login_input_left">
                                    <el-image src="/img/mm.png" class="login_input_left_img"></el-image>
                                </div>
                                <div class="login_input_right">
                                    <el-input type="password" ref="password" v-model.trim="loginData.opmPassword" :show-password="true" size="mini" @input="loginFun" @keyup.enter.native="userLogin()" placeholder="请输入您的密码"></el-input>
                                </div>
                            </div>
                            <div class="login_input_line">
                                <div class="login_input_left">
                                    <el-image src="/img/zz.png" class="login_input_left_img"></el-image>
                                </div>
                                <div class="login_input_right">
                                    <el-select v-model="selectedOrgId" @change="selectDataAction" placeholder="请选择" disabled>
                                        <el-option v-for="item in allorgList" :key="item.value" :label="item.label" :value="item.value">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                            <div class="login_input_line"></div>
                            <div class="login_input_right" style="width: 100%">
                                <el-button type="primary" @click="userLogin()">登录</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="version">
                        <div>版本号：{{ logoInfo.versionNum }}</div>
                        <div>
                            <span>版权所有：</span>
                            <a @click="openPage">{{ logoInfo.copyright }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog title="系统注册" :visible.sync="regDia" width="400px">
            <el-form :model="reg" ref="reg" :rules="regRules">
                <el-form-item label="单位名称：" prop="clName">
                    <el-input v-model="reg.clName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="注册码：" prop="customerCode">
                    <el-input v-model="reg.customerCode" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="regDia = false" size="mini">取 消</el-button>
                <el-button type="primary" :disabled="disabled" @click="confirmReg('reg')" size="mini">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import QRCode from "qrcodejs2";
import CryptoJS from 'crypto-js'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            defaultProps: {
                expandTrigger: "hover",
                checkStrictly: true,
                emitPath: false,
            },
            allorgList: [],
            allorgListCopy: [],
            activeName: "first",
            loginData: {
                opmAccount: "",
                opmPassword: "",
                // imgCode: "",
                ormId: "",
            },

            selectedOrgId: [],
            vcodeImg: "",
            codeShowStatus: false,
            websock: {},
            qrCodeUUID: this.$common.generateUUID(),
            // token:sessionStorage.getItem('token')
            token: "123123",
            regDia: false,
            reg: {
                customerCode: "",
                clName: "",
            },
            regRules: {
                customerCode: [
                    { required: true, message: "请输入注册码", trigger: "blur" },
                ],
                clName: [
                    { required: true, message: "请输入单位名称", trigger: "blur" },
                ],
            },
            logoInfo: {
                copyright: "", //版权所有
                copyrightUrl: "http://www.hndfsoft.com/", // 链接
                mainLogo: "", //登录页面logo
                shortLogo: "", // 首页logo
                versionNum: "", //版本号
            },
            searchEXFlag: false,
            disabled: false,
            loginName: window.global_config.loginName,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        searchEXFlag() {
            if (this.searchEXFlag) {
                this.searchsQuery();
            }
        },
        regDia() {
            if (!this.regDia) {
                this.disabled = false
            }
        },
    },
    //方法集合
    methods: {
        focusClick() {
            this.$refs['password'].focus()
        },
        async loginFun(e) {
            var ormId = window.global_config.BASE_ORMID;
            if (ormId == "" || ormId == null || ormId == undefined) {
                this.loginData.opmPassword = e
                var key = CryptoJS.enc.Utf8.parse('dfsoft.soft.1501');//秘钥
                // // 要加密的字符串
                var data = String(this.loginData.opmPassword)
                // // 加密
                var encrypted = CryptoJS.AES.encrypt(data, key, {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.Pkcs7
                });
                let params = JSON.parse(JSON.stringify(this.loginData))
                params.opmPassword = encrypted.toString();
                let res = await this.$http.loginAcquireOrm(params);
                console.log(res);
                if (
                    res.result &&
                    res.result.ormId != null &&
                    res.result.ormId != "" &&
                    res.result.ormId != undefined
                ) {
                    this.loginData.ormId = Number(res.result.ormId);
                    this.selectedOrgId = Number(res.result.ormId);
                    sessionStorage.setItem("ormId", res.result.ormId);
                    sessionStorage.setItem("ormInfo", JSON.stringify(res.result));
                    this.getOrmName();
                } else {
                    this.loginData.ormId = "";
                    this.selectedOrgId = "";
                    sessionStorage.setItem("ormId", "");
                    sessionStorage.setItem("ormInfo", "");
                }
            }
        },
        async loginFunAcc(e) {
            var ormId = window.global_config.BASE_ORMID;
            if (ormId == "" || ormId == null || ormId == undefined) {
                this.loginData.opmAccount = e;
                var key = CryptoJS.enc.Utf8.parse('dfsoft.soft.1501');//秘钥
                // // 要加密的字符串
                var data = String(this.loginData.opmPassword)
                // // 加密
                var encrypted = CryptoJS.AES.encrypt(data, key, {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.Pkcs7
                });
                let params = JSON.parse(JSON.stringify(this.loginData))
                params.opmPassword = encrypted.toString();
                let res = await this.$http.loginAcquireOrm(params);
                console.log(res);
                if (
                    res.result &&
                    res.result.ormId != null &&
                    res.result.ormId != "" &&
                    res.result.ormId != undefined
                ) {
                    this.loginData.ormId = Number(res.result.ormId);
                    this.selectedOrgId = Number(res.result.ormId);
                    sessionStorage.setItem("ormId", res.result.ormId);
                    sessionStorage.setItem("ormInfo", JSON.stringify(res.result));
                    this.getOrmName();
                } else {
                    this.loginData.ormId = "";
                    this.selectedOrgId = "";
                    sessionStorage.setItem("ormId", "");
                    sessionStorage.setItem("ormInfo", "");
                }
            }
        },
        confirmReg(reg) {
            this.$refs[reg].validate((valid) => {
                if (valid) {
                    this.subCode();
                } else {
                    return false;
                }
            });
        },
        async subCode() {
            this.disabled = true
            let responseData = await this.$http.subRegCode({
                customerCode: this.reg.customerCode,
                clName: this.reg.clName
            });
            this.disabled = false
            if (responseData.status == 200) {
                this.disabled = true
                this.$message({
                    type: "success",
                    message: "注册成功",
                });
                this.regDia = false;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        openRegDia() {
            this.reg.regCode = "";
            this.regDia = true;
        },
        openDownFire() {
            window.location.href = sessionStorage.getItem("downUrl");
        },
        openPage() {
            window.open(this.logoInfo.copyrightUrl);
        },
        createQRcode() {
            new QRCode(this.$refs.qrCodeDiv, {
                text: this.qrCodeUUID,
                width: 180,
                height: 180,
                colorDark: "#333333", //二维码颜色
                colorLight: "#ffffff", //二维码背景色
                correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
            });
        },
        selectDataAction() {
            this.loginData.ormId = this.selectedOrgId;
            this.getOrmName();
            sessionStorage.setItem("ormId", this.selectedOrgId);
        },
        // 获取用户之前登陆的信息
        getLoginInfo() {
            var ormId = window.global_config.BASE_ORMID;
            if (ormId && ormId != "") {
                if (ormId != "" && ormId != null && ormId != undefined) {
                    this.loginData.ormId = Number(ormId);
                    this.selectedOrgId = Number(ormId);
                }
                this.getOrmName();
                sessionStorage.setItem("ormId", this.selectedOrgId);
                return;
            }
        },

        async getOrgList() {
            var _this = this;
            this.allorgList = await this.$common.getALLOrg();
        },
        // 获取logo 登录页信息
        async getlogoInfo() {
            let responseData = await this.$http.getALLOrg();
            if (responseData.status == 200) {
                console.log(responseData.result.desysLogo);
                this.logoInfo = responseData.result.desysLogo;
                sessionStorage.setItem("homeLogo", this.logoInfo.shortLogo);
                sessionStorage.setItem("downUrl", this.logoInfo.downUrl);
                sessionStorage.setItem(
                    "desysLogo",
                    JSON.stringify(responseData.result.desysLogo)
                );
                if (responseData.result.ormList.length > 0) {
                    this.allorgList = this.$common.getSubTree(responseData.result.ormList, 0, 0, "")
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取验证码图片
        async getLoginCode() {
            this.codeShowStatus = false;
            let responseData = await this.$http.getLoginCode();
            if (responseData.status == 200) {
                this.vcodeImg = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
            this.codeShowStatus = true;
        },

        handleClick(tab, event) {
            this.$common.console(tab, event);
        },

        // 用户登录
        async userLogin() {
            this.$common.remove()
            var key = CryptoJS.enc.Utf8.parse('dfsoft.soft.1501');//秘钥
            // // 要加密的字符串
            var data = String(this.loginData.opmPassword)
            // // 加密
            var encrypted = CryptoJS.AES.encrypt(data, key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });
            let params = JSON.parse(JSON.stringify(this.loginData))
            params.opmPassword = encrypted.toString();
            let res = await this.$http.loginAcquireOrm(params);
            if (
                res.result &&
                res.result.ormId != null &&
                res.result.ormId != "" &&
                res.result.ormId != undefined
            ) {
                this.loginData.ormId = Number(res.result.ormId);
                this.selectedOrgId = Number(res.result.ormId);
                sessionStorage.setItem("ormId", res.result.ormId);
                sessionStorage.setItem("ormList", JSON.stringify(this.allorgList.filter(item => item.ormId == res.result.ormId)[0]));
                sessionStorage.setItem("ormInfo", JSON.stringify(res.result));
                this.getOrmName();
            } else {
                this.loginData.ormId = "";
                this.selectedOrgId = "";
                sessionStorage.setItem("ormId", "");
                sessionStorage.setItem("ormInfo", "");
            }
            this.getOrmName();
            var _this = this;
            if (!this.loginData.ormId) return;
            let responseData = await this.$http.userLogin(params);
            if (responseData.status == 200) {
                sessionStorage.setItem(
                    "userInfo",
                    JSON.stringify(responseData.result.operator)
                );
                this.$store.commit(
                    "updateUserInfo",
                    JSON.stringify(responseData.result.operator)
                );

                sessionStorage.setItem("token", responseData.result.token);
                this.$store.commit("updateToken", responseData.result.token);
                var loginData = JSON.parse(JSON.stringify(this.loginData));
                sessionStorage.setItem("loginInfo", JSON.stringify(loginData));
                sessionStorage.setItem("notificationFlagI", true);
                sessionStorage.setItem("notificationFlagII", true);
                sessionStorage.setItem(
                    "systemSettingInfo",
                    JSON.stringify(responseData.result.sysDigits)
                );
                sessionStorage.setItem(
                    "printInfo",
                    JSON.stringify(responseData.result.settings)
                );
                this.$http
                    .desysModulequeryUserjurisdiction({
                        ids: [responseData.result.operator.opmId],
                    })
                    .then((res) => {
                        sessionStorage.setItem(
                            "modulelist",
                            JSON.stringify(res.result)
                        );
                    });
                // 循环存储提取方案
                // let searchEXData = await this.$http.queryExtractPlan();
                this.searchEXFlag = false;
                this.queryOrmRule();
                this.passwordVerification()
            } else if (responseData.status == 300) {
                this.$message({
                    message: responseData.message,
                    type: "warning",
                });

                sessionStorage.setItem(
                    "userInfo",
                    JSON.stringify(responseData.result.operator)
                );
                this.$store.commit(
                    "updateUserInfo",
                    JSON.stringify(responseData.result.operator)
                );
                sessionStorage.setItem("token", responseData.result.token);
                this.$store.commit("updateToken", responseData.result.token);
                var loginData = JSON.parse(JSON.stringify(this.loginData));
                sessionStorage.setItem("loginInfo", JSON.stringify(loginData));
                sessionStorage.setItem(
                    "systemSettingInfo",
                    JSON.stringify(responseData.result.sysDigits)
                );
                sessionStorage.setItem(
                    "printInfo",
                    JSON.stringify(responseData.result.settings)
                );
                this.$http
                    .desysModulequeryUserjurisdiction({
                        ids: [responseData.result.operator.opmId],
                    })
                    .then((res) => {
                        sessionStorage.setItem(
                            "modulelist",
                            JSON.stringify(res.result)
                        );
                    });
                this.searchEXFlag = false;
                this.queryOrmRule();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async queryOrmRule() {
            const ormRules = await this.$http.queryOrmRule();
            const ormRuleData = ormRules.result || [];
            ormRuleData.forEach((item, index) => {
                this.$set(item, "id", item.ruleId)
                this.$dbCache.Record_Add(item).then((msg) => {
                    console.log('写入--->', "成功");
                }).catch(err => {
                    console.log("写入失败--->", err);
                });
                if (ormRuleData.length - 1 == index) {
                    this.$common.pageJump("/");
                    this.extendsQuery()
                }
            });
            if (ormRuleData.length == 0) {
                this.$common.pageJump("/");
                this.extendsQuery()
            }

        },
        async passwordVerification() {
            var key = CryptoJS.enc.Utf8.parse('dfsoft.soft.1501');//秘钥
            // // 要加密的字符串
            var data = String(this.loginData.opmPassword)
            // // 加密
            var encrypted = CryptoJS.AES.encrypt(data, key, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });
            let params = JSON.parse(JSON.stringify(this.loginData))
            params.opmPassword = encrypted.toString();
            const res = await this.$http.checkPassComPlex(params)
            console.log(res);
            if (res.status == 200) {
                sessionStorage.removeItem("loginType")
            } else {
                sessionStorage.setItem("loginType", res.message)
            }

        },
        async extendsQuery() {
            const searchEXData = await this.$http.queryExtractPlan();
            console.log(searchEXData, "searchEXData");
            const searchEXDatas = searchEXData.result || [];
            searchEXDatas.forEach((item, index) => {
                this.$set(item, "id", item.extractId)
                if (item.conditionList == null) {
                    item.conditionList = []
                }
                this.$dbCache.Record_Add(item).then((msg) => {
                    console.log('写入--->', "成功");
                }).catch(err => {
                    console.log("写入失败--->", err);
                });
                if (searchEXDatas.length - 1 == index) {
                    this.searchEXFlag = true;
                }
            });
            if (searchEXDatas.length == 0) {
                this.searchEXFlag = true;
            }
        },
        async searchsQuery() {
            const searchPlanData = await this.$http.querySearchPlan();
            console.log(searchPlanData, "searchPlanData");
            const searchPlanDatas = searchPlanData.result || [];
            searchPlanDatas.forEach((item, index) => {
                this.$set(item, "id", item.searchId)
                if (item.conditionList == null) {
                    item.conditionList = []
                }
                this.$dbCache.Record_Add(item).then((msg) => {
                    console.log('写入--->', "成功");
                }).catch(err => {
                    console.log("写入失败--->", err);
                });
            });
        },
        getConfigResult(e) { },
        //获取组织名称并保存
        getOrmName() {
            if (this.selectedOrgId) {
                let len = this.allorgList.length;
                for (let i = 0; i < len; i++) {
                    if (this.allorgList[i].ormId == this.selectedOrgId) {
                        sessionStorage.setItem("ormName", this.allorgList[i].ormName);
                        break;
                    }
                }
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getlogoInfo().then(() => {
            this.getLoginInfo();
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        // this.createQRcode();
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped="scoped">
.login_form_box {
    height: 230px;
    padding-top: 0.5rem;
}

.login_input_line {
    width: 100%;
    margin-bottom: 0.5rem;
    display: flex;
    align-items: center;
}

.login_input_left {
    width: 10%;
    display: table-cell;
    vertical-align: middle;
    text-align: center;

    /* display: inline-block; */
}

.login_input_left_img {
    height: 24px;
    width: 24px;
}

.login_input_right {
    width: 90%;
    display: inline-block;
}

.el-tabs__content {
    padding: 1rem;
}

.login_logo {
    position: fixed;
    top: 2rem;
    left: 2rem;
}

.login_bg {
    background-image: url(../../public/img/bg.png);
    background-size: 100% 100%;
    width: 100%;
    height: 100vh;
    position: absolute;
    left: 0;
    top: 0;
    min-width: 900px;
}

.login_right_content {
    background-color: #ffffff;
    padding: 2rem 3rem;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 0.5rem;
    padding-bottom: 1rem;
}

.code_img_box {
    width: 30%;
    position: relative;
    display: inline-block;
    text-align: right;
}

.el-image {
    overflow: inherit;
}

.code_img {
    height: 23px;
    width: 60px;
    /* float: left; */
}

.login_content_box {
    margin-top: 1rem;
}

.login_box {
    width: 90%;
    margin: 5vh 5%;
    height: 90vh;
    padding: 1rem 1rem;
    color: #ffffff !important;
}

.login_left {
    width: 60%;
    height: 100%;
    padding: 1rem 5rem;
    display: inline-block;
    font-size: 100%;
    /* display:table; */
    /* transform: scale(0.8); */
}

.login_right {
    width: 40%;
    height: 100%;
    display: inline-block;
    float: right;
    padding: 1rem 5rem;
    font-size: 1rem;
}

.login_left_content {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    /* display:table-cell; vertical-align:middle; */
}

.login_left_two {
    width: 100%;
    margin-top: 1rem;
}

.login_left_icon {
    width: 90%;
}

.left_one {
    width: 10%;
    /* display:table-cell; */
    display: inline-block;
    vertical-align: top;
}

.left_two {
    width: 90%;
    display: inline-block;
}

.left_title {
    color: #6d7276;
    font-weight: bold;
}

.left_title_text {
    margin-top: 1rem;
    color: #333333;
}

.versions_title {
    color: #6d7276;
    font-weight: 600;
    margin-top: 1rem;
}

.versions_title span {
    font-weight: bolder;
}

.white_color {
    color: #ffffff !important;
}

.el-form-item__label {
    color: #ffffff !important;
}

.el-tabs__item {
    color: #ffffff !important;
}

@media screen and (max-width: 1700px) {
    .login_right {
        padding: 1rem 0;
    }
}

.login-tt {
    color: #333333;
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 20px;
}

.blue-line {
    width: 60px;
    height: 6px;
    background-color: #517fe7;
    margin-top: -6px;
}

.login_input_right .el-button {
    width: 100%;
    background-color: #517fe7;
    border-color: #517fe7;
}

.version {
    width: 100%;
    color: #999999;
    font-size: 0.6rem;
    display: flex;
    align-items: center;
    margin-top: 10%;
    justify-content: space-between;
}

.reg {
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: #fff;
    opacity: 0.7;
    cursor: pointer;
}

.down {
    position: absolute;
    top: 1rem;
    right: 6rem;
    color: #fff;
    opacity: 0.7;
    cursor: pointer;
}

.el-select {
    width: 100%;
}

::v-deep .el-input.is-disabled .el-input__inner {
    color: #606266 !important;
}
</style>